import classNames from 'classnames'
import { CaptionMD } from '@/atoms/Text'

interface TheatricalExpressFrequencySelectorProps {
  onClick: (isSub: boolean) => void
  isSubscription: boolean
}

export const TheatricalExpressFrequencySelector: React.FC<TheatricalExpressFrequencySelectorProps> = ({
  onClick,
  isSubscription,
}) => {
  return (
    <div className="relative mx-auto block h-[50px] w-full max-w-[276px] cursor-pointer rounded-full border-2 border-gray-200 bg-gray-100 px-[2px] py-1">
      <div
        className={classNames(
          'absolute w-1/2 h-[42px] top-1/2 -translate-y-1/2 bg-white rounded-full shadow-md transform cursor-pointer transition-transform duration-300 ease-in-out',
          {
            'left-0.5': !isSubscription,
            'right-0.5': isSubscription,
          },
        )}
      ></div>
      <div className="absolute top-0 flex h-full w-full items-center justify-center px-2">
        <CaptionMD
          weight="bold"
          className="flex h-full w-1/2 items-center justify-center"
          color={!isSubscription ? 'black' : 'gray-800'}
          onClick={() => onClick(false)}
        >
          One Time
        </CaptionMD>
        <CaptionMD
          weight="bold"
          className="flex h-full w-1/2 items-center justify-center"
          color={isSubscription ? 'black' : 'gray-800'}
          onClick={() => onClick(true)}
        >
          Monthly
        </CaptionMD>
      </div>
    </div>
  )
}
